import { render, staticRenderFns } from "./HomeMarquee.vue?vue&type=template&id=5048b430&scoped=true"
import script from "./HomeMarquee.vue?vue&type=script&lang=js"
export * from "./HomeMarquee.vue?vue&type=script&lang=js"
import style0 from "./HomeMarquee.vue?vue&type=style&index=0&id=5048b430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5048b430",
  null
  
)

export default component.exports